<template>
  <div class="flex flex-col items-center" :class="destacado ? 'order-first sm:order-none' : ''">
    <!-- Foto del competidor -->
    <div
      class="rounded-full overflow-hidden border-4 shadow-lg mb-3 bg-white flex items-center justify-center flex-shrink-0"
      :class="[borde, fotoSize]"
    >
      <img
        v-if="fotoUrl && !fotoError"
        :src="fotoUrl"
        class="w-full h-full object-cover"
        @error="fotoError = true"
      />
      <span v-else class="text-4xl sm:text-5xl">🥋</span>
    </div>

    <div class="text-2xl sm:text-3xl mb-1">{{ medalla }}</div>

    <!-- Datos del competidor -->
    <div v-if="competidor" class="text-center px-2 mb-3">
      <p class="font-black uppercase leading-tight text-yellow-400" :class="nombreSize">
        {{ competidor.apelido || competidor.nombre_completo }}
      </p>
      <p v-if="competidor.apelido" class="text-xs sm:text-sm text-white leading-tight mt-1 break-words">
        {{ competidor.nombre_completo }}
      </p>
      <p v-if="competidor.escuela_nombre" class="text-xs text-gray-400 mt-1 break-words">{{ competidor.escuela_nombre }}</p>
      <p v-if="competidor.regional_nombre" class="text-xs text-yellow-500">{{ competidor.regional_nombre }}</p>
    </div>
    <p v-else class="text-gray-500 text-sm mb-3">—</p>

    <!-- Pedestal (solo decorativo, altura fija que nunca recorta texto) -->
    <div
      class="w-full max-w-[180px] rounded-t-lg flex items-start justify-center pt-2 font-black text-black shadow-inner"
      :class="[pedestalColor, pedestalAlto]"
    >
      {{ puesto }}
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { getFotoUrl } from '../config'

const props = defineProps({
  competidor: {
    type: Object,
    default: null
  },
  puesto: {
    type: String,
    default: ''
  },
  medalla: {
    type: String,
    default: ''
  },
  borde: {
    type: String,
    default: 'border-gray-500'
  },
  pedestalColor: {
    type: String,
    default: 'bg-gray-400'
  },
  pedestalAlto: {
    type: String,
    default: 'h-12'
  },
  destacado: {
    type: Boolean,
    default: false
  }
})

const fotoError = ref(false)
const fotoUrl = computed(() => getFotoUrl(props.competidor?.foto_url))
const fotoSize = computed(() => (props.destacado ? 'w-28 h-28 sm:w-32 sm:h-32' : 'w-20 h-20 sm:w-24 sm:h-24'))
const nombreSize = computed(() => (props.destacado ? 'text-xl sm:text-2xl' : 'text-base sm:text-lg'))
</script>
